import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions, URLSearchParams } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { ConfigComponent } from './../../config/config';
// import { HttpParams } from '@angular/common/http';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class LoginService {
    constructor(
        public http: HttpClient,
        private config: ConfigComponent
    ) {

    }

    // /**
    //  * consume el servicio de registro de usuario
    //  * @param data 
    //  */
    // singUp(data: any) {
    //     const url = this.config.getUrlOmt() + 'cli/signup';
    //     return this.http.post(url, data);
    // }

    /**
     * consume el servicio de logueo de un usuario
     * @param data 
     */
    login(data: any) {
        const url = this.config.getUrlOmt() + 'cli/login';
        return this.http.post(url, data);
    }

    // /**
    //  * Consume el servicio de cierre de session
    //  * @param data 
    //  */
    // logout(data: any) {
    //     const url = this.config.getUrlOmt() + 'cli/logout';
    //     return this.http.post(url, data);
    // }

    // /**
    //  * Permite obtener el token generado en el login
    //  */
    // public getToken(): string {
    //     return localStorage.getItem('auth_token');
    // }

}




// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/service/login.service.ts